import { DateListHelperInvert } from './DateListHelper'
import { DateStringFormatToBr } from './DateStringFormat'

export const ParserAmenitiesToSave = amenities => {
  if (amenities.length > 0) {
    return amenities
      .filter(amenity => {
        return amenity.selected
      })
      .map(amenity => {
        return { amenitiesId: amenity.id }
      })
  }
  return []
}

export const ParserAmenitiesToEdit = amenities => {
  if (amenities.length > 0) {
    return amenities.map(amenitie => {
      return amenitie.amenitiesId
    })
  }
  return []
}

export const ParserTags = tags => {
  return tags.map(tag => {
    return { tagsId: tag }
  })
}

const ParserUnityImages = images => {
  return images.map(image => {
    return { image: image.image }
  })
}

export const ParseUnitiesImagesList = list => {
  return list.map(item => {
    return { logoPath: item.image, image: null, sended: true }
  })
}

export const ParserUnitiesImagesToSave = list => {
  return list.map(item => {
    return { image: item.logoPath || item.image }
  })
}

export const ParserPartner = partnerToParse => {
  const {
    cnpj,
    fantasyName,
    corporateName,
    slug,
    seoDescription,
    zipcode,
    address,
    number,
    neighborhood,
    complement,
    city,
    uf,
    logo,
    fullNameContact,
    phoneNumberContact,
    CPFContact,
    birthContact,
    emailContact,
    discountAmount,
    hasCourtesy,
    hasDelivery,
    roles,
    userCompanyEmail,
    responsibleUser
  } = partnerToParse

  return {
    companyData: {
      cnpj,
      fantasyName,
      socialName: corporateName,
      slug,
      seoDescription,
      responsibleUser,
      userCompanyEmail
    },
    addressData: {
      zipCode: zipcode,
      address,
      number,
      neighborhood,
      complement,
      city,
      uf
    },
    contactData: {
      birth: DateStringFormatToBr(birthContact),
      cellPhone: phoneNumberContact,
      cpf: CPFContact,
      email: emailContact,
      name: fullNameContact
    },

    contractData: {
      rule: roles,
      discountPercent: discountAmount,
      hasCourtesy,
      deliveryDiscount: hasDelivery
    },
    logoToUpload: logo
  }
}

export const ParserUnity = UnityToParser => {
  // region UnityToParser const
  const {
    cnpj,
    fantasyName,
    corporateName,
    slug,
    seoDescription,
    zipcode,
    address,
    number,
    neighborhood,
    city,
    uf,
    complement,
    contactName,
    contactPhone,
    CPFContact,
    contactEmail,
    birthContact,
    site,
    facebook,
    instagram,
    whatsapp,
    logo,
    PartnerUnityOpeningHours,
    PartnerUnitImagens,
    PartnerUnitAmenities,
    userCompanyEmail
  } = UnityToParser
  // endregion

  return {
    companyData: {
      cnpj,
      fantasyName,
      socialName: corporateName,
      slug,
      seoDescription,
      userCompanyEmail
    },
    addressData: {
      zipCode: zipcode,
      address,
      number,
      neighborhood,
      complement,
      city,
      uf
    },
    contactData: {
      birth: DateStringFormatToBr(birthContact),
      cellPhone: contactPhone,
      cpf: CPFContact,
      email: contactEmail,
      name: contactName
    },
    contractData: {
      validDays: DateListHelperInvert(PartnerUnityOpeningHours)
    },
    unityData: {
      site,
      facebook,
      instagram,
      whatsapp
    },
    logo,
    partnerUnitImages: ParserUnityImages(PartnerUnitImagens),
    partnerUnitAmenities: ParserAmenitiesToEdit(PartnerUnitAmenities)
  }
}
